import { HERO_LINE1, HERO_LINE2, HERO_LINE3 } from '../../constants/localizations/coupon';
import cssVariables from '../../styles/variables';

export const getDefaultHeroMetadata = () => ({
  imageUrl: 'assets/img/landing/carousel/hero-premium-2022-v1.jpg',
  bgColor: cssVariables['--t-sharp'],
  line1: HERO_LINE1,
  line2: HERO_LINE2,
  line3: HERO_LINE3,
  isDefault: true,
});

export const imageBlockMetadata = [
  {
    guideItem: { actions: { play: { guideId: 's20407' } } },
    imageUrl: 'assets/img/landing/parallaxImages/cnn-large-v2.jpg',
    href: '/cnn/',
  },
  {
    guideItem: { actions: { play: { guideId: 's20431' } } },
    imageUrl: 'assets/img/shared/tiles/fox-news-radio-small.jpg',
    href: '/radio/FOX-News-Talk-s20431/',
  },
  {
    guideItem: { actions: { play: { guideId: 's242677' } } },
    imageUrl: 'assets/img/shared/tiles/todays-hits-small-v1.jpg',
    href: '/todays-hits/',
  },
  {
    guideItem: { actions: { play: { guideId: 's297990' } } },
    imageUrl: 'assets/img/shared/tiles/msnow-square.webp',
    href: '/radio/MS-NOW-s297990/',
  },
];
